module.exports = __webpack_public_path__ + "static/media/portfolio_7.314ffa41.jpeg";